module.exports = __webpack_public_path__ + "img/civil-servant-card@2x.9047c82c.png";